export default __webpack_public_path__ + "static/media/pancakeswap-cake-logo.285bc1bc.svg";